import React from 'react';
import './Header.scss';
import { Link } from 'react-router-dom';
import dev from '../../assets/illustration/dev2.svg';

import TypedComponent from '../typed/TypedComponent';
import Social from '../social/Social';

const Header = () => {
	return (
		<section className={'header'}>
			{/* Intro and Social go here */}
			<div className={'header__cta'}>
				<TypedComponent />
				<div className={'text__content--cta u-margin-bottom-small'}>
					
					I am a recent graduate holding a BSc. in Information Technology. I am also a
					focused, motivated proactive learner, great team player and a performance oriented
					individual who enjoys taking on new challenges and takes pride in a job well and
					perfectly done.
					
				{/*	I hold a Bachelors’ of Science Degree in Information Technology from Multimedia 
					University of Kenya. 
					I am a focused, motivated proactive learner and performance oriented {' '}
					<span className={'text__highlight'}>
						 Full Stack Developer
					</span>{' '}
					who posseses a key attention to detail and observes best practices
					 when developing and also able to complete projects within schedule.
				*/}	

				
					<span role='img' aria-label='slight smile'>
					{/*	🙂 */}
					</span>
					.
				</div>
				<Social />
				<div className={'u-margin-top-medium'}>
					{/*<Link to={'#contact'} className={'btn btn-cta'}>*/}
					<a href={'#contact'} className={'btn btn-cta'}>
						Let's Talk &#8594;
					</a>
					{/*</Link>*/}
				</div>
			</div>
			{/* Illustration Goes Here */}
			<div className={'header__visual'}>
				<img
					src={dev}
					className={`header__visual--img`}
					alt='Header Illustration'
				/>
			</div>
		</section>
	);
};
export default Header;
